import { styled, Typography } from '@mui/material'

export const TypographyInline = styled(Typography)(() => ({
  display: 'inline-block',
  paddingBlock: '0.5rem'
}))
